import React, { Component } from 'react';
import Request from '../Request';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      versao: ''
    };
  }

  componentDidMount() {
    Request.getVersaoSistema((versaoSistema) => {
      this.setState({ versao: versaoSistema.versao });
    });
  }

  renderVersaoSistema() {
    if (this.state.versao.length > 0) {
      return (
        <div className="pull-right hidden-xs">
          <b>Versão</b> {this.state.versao}
        </div>
      );
    }
  }

  render() {
    return (
      <footer className="main-footer">
        {this.renderVersaoSistema()}
        Sapitur 1995-{new Date().getFullYear()} | Desenvolvido por <strong><a href="//www.sapitur.com.br" target="_Blank" rel="noopener noreferrer">Sapitur Sistemas</a>.</strong> Todos os direitos reservados.
      </footer>
    );
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/modulos/layout/Footer.js